import { useCallback, useEffect, useState } from "react";
import { useScopeId } from "@core/hooks/useRouteParamId";
import { fetchAllFinanceDeductiblesAsync } from "@features/admin/finance/deductible/services/financeDeductibleSvc";
import { FinanceDeductible } from "@features/admin/finance/deductible/types/financeDeductible";

/** All non-deleted deductibles (active and inactive) for the category and rule editors. */
export function useDeductibleCatalog(enabled: boolean = true) {
    const nationId = useScopeId() ?? 0;
    const [catalog, setCatalog] = useState<FinanceDeductible[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const reload = useCallback(async () => {
        if (!enabled || !nationId) return;
        setLoading(true);
        setError(null);
        try {
            setCatalog(await fetchAllFinanceDeductiblesAsync(nationId));
        } catch (e: any) {
            setError(e?.message ?? "Failed to load deductibles.");
        } finally {
            setLoading(false);
        }
    }, [enabled, nationId]);

    useEffect(() => { void reload(); }, [reload]);

    return { catalog, loading, error, reload };
}
